import yup from 'utils/yup';

export interface IInitialMassJobsFormData {
  all_users: number;
  job_ids: any[];
  user_ids: any[];
}

export const initialMassJobsFormData = {
  all_users: 0,
  job_ids: [],
  user_ids: [],
};

export const massJobsFormValidationSchema = yup.object().shape({});
